import { createContext } from "react";

import { EMPTY_APPLIED_FILTER_CHIPS } from "./constants";
import type { FiltersV2RegistryContextValue, FiltersV2StateContextValue } from "./types";

const removeChipNoop = () => {};
const clearAllNoop = () => {};

export const FiltersV2RegistryContext = createContext<FiltersV2RegistryContextValue | null>(null);
export const FiltersV2StateContext = createContext<FiltersV2StateContextValue>({
  chips: EMPTY_APPLIED_FILTER_CHIPS,
  appliedFilterCount: 0,
  hasAppliedFilters: false,
  removeChip: removeChipNoop,
  clearAll: clearAllNoop,
});
